<template>
  <el-dialog
    :visible.sync="empowerVisible"
    title="授权列表"
    custom-class="empowerDialog"
    width="880px"
    :before-close="beforeClose"
  >
    <div class="btn-list">
      <el-button
        class="to-right"
        type="primary"
        @click="handleAdd"
      >
        新增授权
      </el-button>
    </div>
    <div class="list-table">
      <el-table
        v-loading="loading"
        :data="list"
        height="100%"
        border
        highlight-current-row
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
        >
          <template slot-scope="scope">
            {{ (scope.$index+1)+ (page-1)*size }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in EM_POWER_TABLE_COLUMN"
          :key="index"
          v-bind="item"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'action'">
              <el-popconfirm title="确认取消授权?" @confirm="handleCancel(scope.row)">
                <el-button slot="reference" type="text">
                  取消授权
                </el-button>
              </el-popconfirm>
            </div>
            <span
              v-else
              v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      ref="levelRightsPagination"
      :total="total"
      :current-page="page"
      :page-size="size"
      @search="getEmpowerList"
    />
    <el-dialog
      :visible.sync="innerVisible"
      title="授权"
      destroy-on-close
      append-to-body
      width="480px"
    >
      <el-form
        ref="formEmpowerRef"
        :model="empowerForm"
        label-width="100px"
      >
        <!-- 被授权人员 -->
        <el-form-item
          label="被授权人员"
          prop="users"
          :rules="[{ required: true, message: '请选择管控人员', trigger: 'blur' }]"
        >
          <el-select
            v-model="empowerForm.users"
            style="width: 100%;"
            clearable
            filterable
            collapse-tags
            value-key="unifyId"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="(item) in unifyUserList"
              :key="item.unifyId"
              :label="item.unifyName"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <!-- 禁用说明 -->
        <el-form-item
          label="授权说明"
          prop="reason"
          :rules="[{ required: true, message: '请写明授权原因', trigger: 'blur' }]"
        >
          <el-input
            v-model="empowerForm.reason"
            placeholder="请写明授权原因"
            type="text"
          />
        </el-form-item>

      <!-- 授权时效 -->
      <!-- <el-form-item
        label="启用时间"
        prop="autoEnableTime"
      >
        <el-date-picker
          v-model="empowerForm.unifyId"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        />
      </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="innerVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="loading"
          @click="handleSubmit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { controlPage, upsertEmpower, fetchEmpowerList } from '@/api/userControl';
import Pagination from '@/components/Pagination/index.vue';

import { EM_POWER_TABLE_COLUMN } from '../constant';

const initForm = () => ({
  unifyId: '',
  controlId: '',
  reason: '',
  users: [],
});

export default {
  name: 'EmpowerDialog',
  components: {
    Pagination,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      EM_POWER_TABLE_COLUMN,
      empowerForm: initForm(),
      loading: false,
      unifyUserList: [],
      innerVisible: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
      tableLoading: false,
    };
  },
  computed: {
    empowerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    rowInfo: {
      get() {
        return this.currentRow;
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.getEmpowerList();
      } else {
        this.list = [];
        this.total = 0;
      }
    },
    innerVisible(val) {
      if (val) {
        this.fetchPeopleList();
      } else {
        this.unifyUserList = [];
      }
    },
  },
  methods: {
    async handleCancel(row) {
      try {
        const data = {
          unifyId: this.currentRow.unifyId,
          controlId: this.currentRow.id,
          operateType: 'REMOVE',
          users: [row],
        };
        this.loading = true;
        await upsertEmpower(data);
        this.$message.success('操作成功');
        this.page = 1;
        this.getEmpowerList();
        this.innerVisible = false;
      } finally {
        this.loading = false;
      }
    },
    async getEmpowerList(page, size) {
      this.tableLoading = true;
      try {
        this.page = page || this.page;
        this.size = size || this.size;
        const data = {
          unifyId: this.currentRow.unifyId,
          controlId: this.currentRow.id,
        };
        const params = {
          page: this.page,
          size: this.size,
        };
        const res = await fetchEmpowerList(data, params);
        this.list = res.records || [];
        this.total = res.total;
      } finally {
        this.tableLoading = false;
      }
    },
    beforeClose() {
      this.$emit('refresh');
      this.empowerVisible = false;
    },
    handleAdd() {
      this.innerVisible = true;
      this.$nextTick(() => {
        this.empowerForm = initForm();
      });
    },
    async handleSubmit() {
      try {
        await this.$refs.formEmpowerRef.validate();
        try {
          const usersInfo = this.empowerForm.users.map((item) => ({
            authorizedUnifyId: item.unifyId,
            authorizedUnifyName: item.unifyName,
            companyId: item.companyId,
            companyName: item.companyName,
          }));
          const data = {
            unifyId: this.currentRow.unifyId,
            controlId: this.currentRow.id,
            reason: this.empowerForm.reason,
            users: usersInfo,
          };
          this.loading = true;
          await upsertEmpower(data);
          this.$message.success('授权成功');
          this.getEmpowerList();
          this.innerVisible = false;
        } finally {
          this.loading = false;
        }
      } catch (err) {
        const error = err[Object.keys(err).shift()].shift();
        this.$message.warning(error.message);
      }
    },
    async fetchPeopleList() {
      try {
        const params = {
          page: 1,
          size: 5000,
          sort: 'update_time__DESC',
        };
        const resp = await controlPage({
          needConfigDetail: true,
        }, params);
        this.unifyUserList = resp.records;
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.empowerDialog{
  .btn-list{
    margin-top: -15px;
    overflow: hidden;
  }
  .list-table{
    margin-top: 20px;
    height: 430px;
  }
  .to-right{
      float: right;
    }
}
</style>
